import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_memoru_album = _resolveComponent("memoru-album")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_memoru_sales = _resolveComponent("memoru-sales")!
  const _component_memoru_purchase_history = _resolveComponent("memoru-purchase-history")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      grow: "",
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "album" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("アルバム", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "sales" }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("売上情報", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "purchase-history" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("購入履歴", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_divider),
    _createVNode(_component_v_window, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
      class: "mt-6"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "album" }, {
          default: _withCtx(() => [
            _createVNode(_component_memoru_album)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "sales" }, {
          default: _withCtx(() => [
            _createVNode(_component_memoru_sales)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "purchase-history" }, {
          default: _withCtx(() => [
            _createVNode(_component_memoru_purchase_history)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}